/**
 * First letter shown when the user has no profile photo.
 */
export function getProfileInitial(profile) {
  const first = profile?.firstName?.trim();
  if (first) return first[0].toUpperCase();

  const last = profile?.lastName?.trim();
  if (last) return last[0].toUpperCase();

  const email = profile?.email?.trim();
  if (email) return email[0].toUpperCase();

  return '?';
}
